import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import Loading from '../Loading'
import { dispatcher, pathFactory, paths } from '../links'
import SignInStore from './stores/SignInStore'
import useRecaptcha from './useRecaptcha'
import SignupStore from './stores/SignupStore'
import { MESSAGE_TYPE, useMessage } from '../../utils/helpers/MessageProvider'
import useUtm from './useUtm'

//http://localhost:3000/auth?phone=7025555555 existing user
//http://localhost:3000/auth?phone=7023542321 new user

export default observer(({ navigation, route }) => {
  const { params } = route
  useUtm(params)
  const recaptcha = useRecaptcha()
  const { verifier, createVerifier } = recaptcha

  const [exists, setExists] = useState<null | boolean>(null)

  const { setMessage } = useMessage()

  useEffect(() => {
    if (!verifier) createVerifier()
  }, [createVerifier, verifier])

  useEffect(() => {
    if (params && params.phone) {
      const { phone } = params
      SignInStore.setLogin(phone)
      if (SignInStore.isValidLogin) {
        SignInStore.checkIsExist().then((r) => {
          setExists(r)
        })
      } else {
        setMessage(MESSAGE_TYPE.ERROR, 'Invalid login parameter')
        navigation.navigate(paths.Home._self)
      }
    }
  }, [navigation, params, params.phone, setMessage])

  useEffect(() => {
    if (exists === null) return
    if (verifier) {
      if (exists) {
        SignInStore.signIn(verifier)
        if (SignInStore.canAskOtp) {
          const action = dispatcher(pathFactory('Auth.SignInVerify'), {
            action: 'request-credit',
          })
          navigation.replace(action.name, action.params)
        }
      } else {
        SignupStore.setLogin(params?.phone)
        SignupStore.setValue('phone', params?.phone)
        SignupStore.setValue('type', 'code')
        SignupStore.initPhoneVerify(verifier).then(() => {
          const action = dispatcher(pathFactory('Auth.SignUpVerify'), {
            action: 'request-credit',
          })
          navigation.replace(action.name, action.params)
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exists, navigation, params?.phone, verifier, SignInStore.canAskOtp])

  if (!params || !params.phone) {
    navigation.navigate(paths.Home._self)
    return null
  }

  return <Loading />
})
